// Copyright 2024 Vajra. All rights reserved.
// Reports Page

export default function ReportsPage() {
  return (
    <div>
      <h1 className="text-2xl font-semibold text-gray-900">Reports</h1>
      <p className="mt-2 text-sm text-gray-700">
        Generate and schedule security reports.
      </p>
      {/* Reports list would go here */}
    </div>
  );
}
